import { SEO_KEYWORDS, SITE_NAME } from "./constants";

const keywords = SEO_KEYWORDS.join(", ");

export const PAGE_SEO = {
  "/": {
    title: "Rahul Engineering Works",
    description:
      "Manufacturer of bakery machines, ovens, mixers, conveyors, slicers since 1992. Bread, rusk/toast and biscuit machinery.",
    keywords,
    path: "/",
  },
  "/products": {
    title:
      "Bakery Ovens, Mixers & Slicers | Bakery Machines | Rahul Engineering Works Kanpur",
    description:
      "Catalog of bakery machines from Rahul Engineering Works Kanpur: rotary rack oven, tunnel oven, spiral mixer, planetary mixer, bread slicer, rusk line & industrial bakery equipment. Made in India.",
    keywords: [
      "bakery machines",
      "bakery oven",
      "industrial oven Kanpur",
      "spiral mixer",
      "planetary mixer",
      "bread slicer",
      "rusk slicer",
      "rahul engineering works kanpur",
      "bakery equipment kanpur",
      ...SEO_KEYWORDS,
    ].join(", "),
    path: "/products",
  },
  "/clients": {
    title: "Bakery Machine Clients India | Rahul Engineering Works Kanpur",
    description:
      "750+ bakeries and food brands trust Rahul Engineering Works Kanpur for bakery machines, ovens, mixers and slicers — pan-India supply from India's leading industrial bakery equipment manufacturer.",
    keywords: [
      "rahul engineering works kanpur",
      "bakery machines kanpur",
      "bakery equipment manufacturer india",
      ...SEO_KEYWORDS,
    ].join(", "),
    path: "/clients",
  },
};

export const getPageSeo = (pathname) => PAGE_SEO[pathname] || PAGE_SEO["/"];
